// Trend Sound types based on API documentation

export type TrendSoundType = 'original' | 'music' | 'sound_effect' | 'voice_over'
export type TrendSoundStatus = 'active' | 'hidden' | 'deleted' | 'banned'

export interface TrendSoundUser {
  uid: string
  displayName: string
  photoURL: string | null
}

export interface TrendSound {
  id: string
  title: string
  artist: string | null
  audioUrl: string
  coverUrl: string | null
  duration: number
  type: TrendSoundType
  status: TrendSoundStatus
  usageCount: number
  likeCount: number
  tags: string[]
  isLiked: boolean
  user: TrendSoundUser
  createdAt: string
  updatedAt: string
}

// Pagination response type
export interface TrendSoundListResponse {
  data: TrendSound[]
  total: number
  page: number
  limit: number
  hasMore: boolean
}

// Trend Sound filter types
export interface TrendSoundFilters {
  page: number
  limit: number
  search?: string
  type: string
  status: string
  orderBy: string
}

// Pagination meta type
export interface PaginationMeta {
  limit: number
  page: number
  total: number
}

// Create trend sound data type
export interface CreateTrendSoundData {
  title: string
  artist?: string
  audioUrl: string
  coverUrl?: string
  duration?: number
  type?: TrendSoundType
  tags?: string[]
}

// Update trend sound data type
export interface UpdateTrendSoundData {
  title?: string
  artist?: string
  audioUrl?: string
  coverUrl?: string
  duration?: number
  type?: TrendSoundType
  tags?: string[]
}

// File upload type
export interface FileUpload {
  url: string | File
  fileName: string
}

// Type options for select
export const TREND_SOUND_TYPE_OPTIONS: {
  value: TrendSoundType
  label: string
}[] = [
  { value: 'original', label: 'เสียงต้นฉบับ' },
  { value: 'music', label: 'เพลง' },
  { value: 'sound_effect', label: 'เอฟเฟกต์เสียง' },
  { value: 'voice_over', label: 'พากย์เสียง' },
]

// Status options for select
export const TREND_SOUND_STATUS_OPTIONS: {
  value: TrendSoundStatus
  label: string
}[] = [
  { value: 'active', label: 'เปิดใช้งาน' },
  { value: 'hidden', label: 'ซ่อน' },
  { value: 'deleted', label: 'ลบแล้ว' },
  { value: 'banned', label: 'ถูกแบน' },
]
